import React, { Component } from "react";
import {
  Button,
  Card,
  CardBody,
  CardGroup,
  Col,
  Container,
  Form,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";

class LoginWithEmail extends Component {
  render() {
    return (
      <CardBody className="m-3">
        <Form onSubmit={this.props.handleSubmit}>
          {/* <h2 className="text-primary text-center">Login</h2> */}
          {/* <p className="text-muted text-center">Sign In to your account</p> */}
          <Row>
            <Col lg={12}><h2 className="loginText">Login Section for</h2></Col>
            <Col lg={12}><p className="Practitioner-text paragraph-style">Practitioners</p></Col>
            <Col lg={10} md={10}>
            <div className="para">
            <p className="paraText paragraph-style">
              Millions of women are looking for the right expert on momkidcare.
              Register & start your journey now!
            </p>
          </div>
            </Col>
          </Row>
       <Row className="mb-2 mt-4">
        <Col lg={10}>
        <InputGroup className="textMobile">
            <InputGroupAddon addonType="prepend">
              <InputGroupText className="inputGroupLogin">
                <i class="bi bi-envelope-fill inputIconLogin"></i>
              </InputGroupText>
            </InputGroupAddon>
            <Input
              className="login-pass-Text inputTextFill"
              type="text"
              placeholder="Email Id"
              onChange={this.props.handleOnChange}
              name="username"
              value={this.props.username}
              required
            />
          </InputGroup>
        </Col>
       </Row>
         <Row className="mb-4">
          <Col lg={10}>
          <InputGroup>
            <InputGroupAddon addonType="prepend">
              <InputGroupText className="inputGroupLogin">
                <i className="bi bi-lock-fill inputIconLogin"></i>
              </InputGroupText>
            </InputGroupAddon>
            <Input
              type="password"
              placeholder="Password"
              name="password"
              value={this.props.password}
              onChange={this.props.handleOnChange}
              autoComplete="off"
              required
              className="login-pass-Text inputTextFill"
            />
          </InputGroup>
          </Col>
         </Row>
          <Row className="text-center">
            <Col xs={12} lg={10}>
              <Button className="mt-2 colorOfBtn" color="warning">
                Login
              </Button>
            </Col>
            <Col xs="12" className="mt-2" lg={10}>
              <span
                className="loginOtp"
                onClick={(e) => this.props.changeStatusHandler("1")}
              >
                Login with OTP
              </span>
            </Col>
            <Col xs="12" lg={10}>
              <p className="or-text paragraph-style">
                <span>----------</span>or<span>----------</span>
              </p>
            </Col>
            <Col xs="12" lg={10}>
              <span className="loginDonthave">Don’t have an account yet?</span>
            </Col>
            <Col xs="12" lg={10}>
              <p
                className="createAccount paragraph-style"
                onClick={(e) => this.props.changeStatusHandler("2")}
              >
                Create an account
              </p>
            </Col>
          </Row>
        </Form>
      </CardBody>
    );
  }
}

export default LoginWithEmail;
